module.exports = __webpack_public_path__ + "img/video-cover-3.5585ba7e.png";